// Direction-aware horizontal multiplier for GSAP `x:` entrance animations.
// LTR returns +1, RTL returns -1, so `x: -60 * dir` slides from the logical
// start in both locales (left in LTR, right in RTL).
export function useDirX() {
  const { localeProperties } = useI18n()
  return computed(() => (localeProperties.value.dir === 'rtl' ? -1 : 1))
}
